import {UserAddress} from "../types/types";

export const addressSort = (data: UserAddress[]) => {
    data.sort((a, b) => b.addressId - a.addressId);
    return data.slice(0, 5);
}